import React, {useState} from 'react';
import {
    Button, Icon, TextField
} from '@shopify/polaris';

import {TickSmallMinor} from '@shopify/polaris-icons';
import {updateDeliveryEstimateForVariant} from '../../services/deliveryEstimate';

function VariantDeliveryEstimateEdit(props: any){

  const { handle, variant_id, delivery_max, delivery_min } = props;
  const [deliveryEstimate, setDeliveryEstimate] = useState({
    delivery_max,
    delivery_min
  });

  const handleOnSave = () => {
    updateDeliveryEstimateForVariant(handle, {
      variant_id,
      delivery_max: deliveryEstimate.delivery_max,
      delivery_min: deliveryEstimate.delivery_min
    }).then(() => {});
  }

  const handleValueChange = (e: any) => {
    const var_type = e.target.name;
    const value = e.target.value;
    setDeliveryEstimate({...deliveryEstimate, [var_type]: value});
    //console.log(e, {...deliveryEstimate, [var_type]: value});
  };

  return (
  <>
    <div className="estimate-body__col2">
      <input
        type="text"
        className="delivery-estimate-input"
        value={deliveryEstimate.delivery_min}
        name="delivery_min"
        onChange={handleValueChange} />
    </div>
    <div className="estimate-body__col3">
      <input
        type="text"
        className="delivery-estimate-input"
        value={deliveryEstimate.delivery_max}
        name="delivery_max"
        onChange={handleValueChange} />
    </div>
    <div className="estimate-body__col4">
      <Button
        primary
        icon={(<Icon source={TickSmallMinor} />)}
        size="slim" 
        onClick={handleOnSave}></Button>
    </div>
  </>
  );
}

export default VariantDeliveryEstimateEdit;